GET_PM_SECTION_DATE_CACHE_TIME